import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectTenantConfig } from 'brain-data/store/selectors/config.selector';
import { State } from 'reducers';
import { originOf } from './protected-api-url';

/**
 * The payments API ORIGIN the session bearer may travel to, as the tenant config handed it down
 * (`TenantConfig.paymentsApiUrl` — composed server-side from the Terraform-injected origin
 * template; never derived here from the hostname, never a literal in this bundle). BRN-2325 AC12.
 *
 * A synchronous SNAPSHOT of the store rather than an observable, because `HttpInterceptor.intercept`
 * decides synchronously and the credential predicate is a pure function of the url and this value.
 * It is `null` until the first tenant config lands and `null` wherever the environment runs no
 * payments — and in both cases the credential scope is exactly the pre-BRN-2325 one: brain's own
 * API and brain-iam, nothing wider. The snapshot follows every later emission, so a config reload
 * that drops the origin withdraws the credential on the next request.
 *
 * This is the ONE place the payments origin is read for the credential boundary (design L2-2's
 * "wired in ONE place"); the page's typed client reads the same store field for its base url.
 */
@Injectable({ providedIn: 'root' })
export class PaymentsApiOriginService {
  private origin: string | null = null;

  constructor(store: Store<State>) {
    store.select(selectTenantConfig).subscribe(config => {
      this.origin = config?.paymentsApiUrl ? originOf(config.paymentsApiUrl) : null;
    });
  }

  /** The exact origin (scheme, host, port) the bearer may be attached to, or `null` for "none". */
  get current(): string | null {
    return this.origin;
  }
}
